import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import EditorialMarquee from "@/components/landing/Marquee";
import Trust from "@/components/landing/Trust";
import Services from "@/components/landing/Services";
import ExpertPanel from "@/components/landing/ExpertPanel";
import Manifesto from "@/components/landing/Manifesto";
import Founder from "@/components/landing/Founder";
import Testimonials from "@/components/landing/Testimonials";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import BookingDialog from "@/components/landing/BookingDialog";

function Landing() {
  useLenis();
  return (
    <main className="bg-ov-bone font-body antialiased overflow-x-hidden">
      <Navbar />
      <Hero />
      <EditorialMarquee />
      <Trust />
      <Services />
      <ExpertPanel />
      <Manifesto />
      <Founder />
      <Testimonials />
      <Contact />
      <Footer />
      <BookingDialog />
    </main>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
